import { render, staticRenderFns } from "./RecommendedGloss.vue?vue&type=template&id=b085e406&scoped=true&lang=pug&"
import script from "./RecommendedGloss.vue?vue&type=script&lang=js&"
export * from "./RecommendedGloss.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedGloss.vue?vue&type=style&index=0&id=b085e406&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b085e406",
  null
  
)

export default component.exports